import { useDebounce } from '@shared/hooks'

import { useFiltersContext } from '@/context'
import { PropertyQueries } from '@/graphql/queries/property.queries'
import { PropertiesFilterParams, PropertyResponse } from '@/types/Property'
import { getPropertiesFilterParams } from '@/util/FiltersUtil'

import { useGraphql } from '../useGraphql'

const useProperties = () => {
  const [{ marketSegmentFilter, propertiesFilters, searchString }] = useFiltersContext()
  const debouncedSearch = useDebounce(searchString, 1000)

  const filterParams: Partial<PropertiesFilterParams> = {
    marketSegmentIds: marketSegmentFilter.marketSegmentIds,
    ...getPropertiesFilterParams(propertiesFilters),
  }
  return useGraphql<{ properties: PropertyResponse[] }>(
    PropertyQueries.QUERY_KEYS.getPropertiesList,
    PropertyQueries.getPropertiesList(),
    {
      filter: filterParams,
      searchString: debouncedSearch,
    },
  )
}

export default useProperties
